import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SliderMovie from './SliderMovie';
import { useHistory } from 'react-router-dom';

const TopRated = () => {
    //Backend
    const [topRated, setTopRated] = useState([]);
    const history = useHistory();

    useEffect(() => {
        axios.get("https://api.themoviedb.org/3/movie/top_rated?api_key=7c767d3b131d9b742f3b12a5945c3a74&language=fr-CA&page=1").then((res) => setTopRated(res.data.results));
    }, []);

    //Front
    return (
        <div className='movieHomeSection'>
            <h1>Mieux notés</h1>
            <div className='main' id="topRatedMovieId">
                {<div className='sectionMovie'>
                    {topRated.map((m) => (
                        <SliderMovie movie={m} key={m.id}onClickMovie={() => history.push('/movieDetails', { id: m.id })} />
                    ))}
                </div>}
            </div>

        </div>
    )
}

export default TopRated;